import { createSelector } from "@reduxjs/toolkit";
import { api } from "./api/reviewsApi";

const selectReviewsResult = api.endpoints.getReviews.select(undefined);

export const selectAllReviews = createSelector(selectReviewsResult, (result) => result.data?.reviews ?? []);

export const selectForModeration = createSelector(selectAllReviews, (reviews) =>
  reviews.filter((r) => r.status === "pending"),
);

export const countForModeration = createSelector(selectForModeration, (reviews) => reviews.length);

export const selectRejected = createSelector(selectAllReviews, (reviews) =>
  reviews.filter((r) => r.status === "rejected"),
);

export const selectMyReplies = (visitorId: string) =>
  createSelector(selectAllReviews, (reviews) => reviews.filter((r) => r.visitor_id === visitorId));

export const selectByEntity = (entityType: string, entityId: number) =>
  createSelector(selectAllReviews, (reviews) =>
    reviews.filter((r) => r.entity_type === entityType && r.entity_id === entityId),
  );
